module.exports = __webpack_public_path__ + "img/historicalPlans.3082e87d.svg";